import { useState, useEffect } from 'react';
import { PapiDeviation } from '@wix/da-types-papi';
import { DeviationFile } from '@wix/da-shared-react/pkg/types/deviation';
import MediaService from '@wix/da-shared-react/pkg/utils/DeviationMediaService';

export default function useBestFittingImage(
  deviation: PapiDeviation,
  containerWidth: number,
  containerHeight: number
) {
  const pickImage = () =>
    MediaService.getFullviewForSize(deviation, containerWidth, containerHeight);

  const [pickedImage, setPickedImage] = useState<DeviationFile | undefined>(
    pickImage
  );

  // When container size grows, try to upgrade to a larger image, if available
  useEffect(() => {
    if (
      pickedImage &&
      (containerWidth > pickedImage.width! ||
        containerHeight > pickedImage.height!)
    ) {
      const newPick = pickImage();
      if (pickedImage !== newPick) {
        setPickedImage(newPick);
      }
    }
  }, [containerWidth, containerHeight, pickedImage]);

  return pickedImage;
}
